<template>
  <div class="form-page">
    <div class="tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <div
      :class="['form-input__wrap', `named-wrapper__${field.name}`]">
      <!-- new-masked-input -->
      <input
        ref="new-masked-input"
        v-if="showInput"
        :type="inputType"
        :inputmode="(inputType === 'tel') ? 'number' : 'string'"
        class="form-input"
        v-model="inputVal"
        v-maska="mask"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup="handleKeyup"
        @input="handleInput"
        :name="history[currentStep].name"
        v-bind:class="{error: history[currentStep].showError || invalidFromBackend}"
        :placeholder="placeholder"
        required>
      <label
        v-if="newDesign"
        class="input__overlay"
      >
        <div class="input__mask">
          <div class="input__mask__invisible">{{ invisibleNumbers }}</div>
          <div class="input__mask__underlines">{{ underlines }}</div>
        </div>
      </label>
      <span
        class="form-input-floating-label"
        v-bind:class="{error: history[currentStep].showError || invalidFromBackend}"
      >
        <img v-if="history[currentStep].name === 'bank_account_number'" :src="`https://cdn.crezu.net/game_flow/src/assets/img/${country === 2 ? 'clabe' : 'iban'}.svg`"/>
        {{history[currentStep].field.label}}
      </span>
      <span
        v-if="newDesign && history[currentStep].name === 'bank_account_number'"
        class="form-input__mark"
      >
        <transition name="fade">
          <img
            v-if="history[currentStep].isValid"
            src="https://cdn.crezu.net/game_flow/src/assets/img/valid_new.svg" alt="">
        </transition>
        <transition name="fade">
          <img
            @click="clearInput"
            v-if="history[currentStep].showError || invalidFromBackend"
            src="https://cdn.crezu.net/game_flow/src/assets/img/invalid_new.svg"
            alt=""
          >
        </transition>
      </span>
    </div>
    <div v-if="history[currentStep].name === 'nip' && +country === 14" class="skip-nip">
      Nie mam teraz NIP-u – <a @click="skipPLNip">pomiń ten krok</a>
    </div>
    <transition name="fade">
      <span class="error-message" v-if="history[currentStep].showError || invalidFromBackend">
        {{history[currentStep].field.error}}
      </span>
    </transition>
    <Checkbox
      v-if="history[currentStep].name === 'phone' && country !== 14"
      name="agreements"
      :show-error="!checked && history[currentStep].showCheckboxError"
      v-model="checked"
      @change="checkboxChanged"
    >
      <p v-html="privacyCheckboxText"></p>
    </Checkbox>
    <Checkbox
      v-if="field.field && field.field.ignore"
      name="ignore"
      :show-error="false"
      v-model="ignoreCheckboxChecked"
      @change="ignoreCheckboxChanged"
    >
      <p v-html="field.field.ignore"></p>
    </Checkbox>
    <RemoteAgreements
      v-if="history[currentStep].name === 'phone' && country === 14"
      :show-error="!accepted && history[currentStep].showCheckboxError"
      :value="!!accepted"
      @change="checkboxChanged"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Checkbox from '../assetComponents/Checkbox'
import { validatePolish } from 'validate-polish'
import RemoteAgreements from '../assetComponents/RemoteAgreements.vue'
const ibantools = require('ibantools')

export default {
  name: 'SimpleInput',
  components: { RemoteAgreements, InfoIcon, Checkbox },
  data () {
    return {
      inputVal: '',
      checked: false,
      ignoreCheckboxChecked: false,
      newDesign: window.newDesign,
      underlines: '',
      invisibleNumbers: ''
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      showInput: state => state.showInput,
      config: state => state.config,
      provider: state => state.additionalParams.provider,
      country: state => state.additionalParams.country,
      fieldName: state => state.history[state.currentStep].name,
      field: state => state.history[state.currentStep],
      privacyCheckboxText: state => {
        const crezuCheckboxText = state.config.params.privacyCheckboxText
        const landingCheckboxText = state.config.params.privacyCheckboxTextLanding
        const hostname = window.location.hostname
        const sites = ['crezu', 'andacredito', 'pezetita', 'finteres', 'cashspace']
        for (const site of sites) {
          if (hostname.includes(site)) return crezuCheckboxText
        }
        return landingCheckboxText
      },
      accepted: state => state.additionalParams.is_terms_accepted || false
    }),
    mask () {
      let mask = this.field.field['game-mask']
      if (mask && mask.includes('["')) {
        mask = JSON.parse(mask)
      }
      return mask
    },
    isValid () {
      const val = this.inputVal
      const valNoSpaces = this.inputVal.replaceAll(' ', '')
      const regex = new RegExp(this.history[this.currentStep].field.reg, 'gi')
      const regexNoSpaces = new RegExp(this.history[this.currentStep].field.reg.replaceAll('\\s', ''), 'gi')
      if (+this.country === 14 && this.field.name === 'pesel') return validatePolish.pesel(val)
      if (+this.country === 14 && this.field.name === 'bank_account_number') return ibantools.isValidIBAN(val.split(' ').join(''))
      const ignore = this.field.field.ignore && this.ignoreCheckboxChecked
      return regex.test(val) || regexNoSpaces.test(valNoSpaces) || ignore
    },
    invalidFromBackend () {
      let result = false
      let values = this.history[this.currentStep].invalidValues
      if (values && (values.includes(this.inputVal) || values.includes(this.inputVal.replaceAll(' ', '')))) result = true
      return result
    },
    placeholder () {
      return this.field.field.placeholder
    },
    inputType: function () {
      let type = this.field.field.type
      if (this.fieldName === 'zip') type = 'tel'
      if (this.fieldName === 'email') type = 'email'
      return type
    }
  },
  beforeMount () {
    this.checked = !!this.accepted
  },
  mounted () {
    let savedValue = this.field.value
    if (this.mask === '##/##/####') savedValue = this.dateFormatter(savedValue)
    if (this.mask === '##/####') {
      savedValue = this.dateFormatter(savedValue)
      if (savedValue.length === 10) savedValue = savedValue.slice(3)
    }
    this.inputVal = savedValue || this.field.field.value || ''
  },
  watch: {
    inputVal: function (val) {
      if (this.mask === '##/##/####') val = this.dateFormatter(val) // date field
      if (this.mask === '##/####') val = this.dateFormatter('01/' + val) // month-year field
      this.$store.commit('UPDATE_FIELD', {isValid: this.isValid, value: val})
    }
  },
  methods: {
    handleKeyup (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
      this.setOverlayText()
    },
    handleFocus (e) {
      this.setOverlayText()
    },
    handleBlur (e) {
      this.underlines = ''
      this.invisibleNumbers = ''
    },
    handleInput (e) {
      this.inputVal = e.target.value
      this.setOverlayText()
    },
    setOverlayText () {
      const val = this.inputVal ? this.inputVal.trim() : ''
      this.underlines = this.placeholder.slice(val.length)
      this.invisibleNumbers = val
    },
    checkboxChanged (e) {
      console.log('checkboxChanged', e)
      let val = e ? 'on' : ''
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { is_terms_accepted: val })
      if (val) this.$store.dispatch('sendCrezuEvent', {
        id: 5, data: {
          sub4: 'fieldFilled',
          sub5: 'agreements',
        }
      })
    },
    ignoreCheckboxChanged () {
      this.$store.commit('UPDATE_FIELD', {
        isValid: this.ignoreCheckboxChecked ? true : this.isValid,
        value: this.ignoreCheckboxChecked ? 'IGNORE' : this.inputVal,
        ignore: this.ignoreCheckboxChecked
      })
    },
    dateFormatter (date) {
      if (!date) return ''
      if (date.includes('/')) return date.replaceAll('/', '-')
      else if (date.includes('-')) return date.replaceAll('-', '/')
    },
    clearInput () {
      this.inputVal = this.field.field.value || ''
    },
    skipPLNip () {
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: 'IGNORE', skip: true })
      this.$store.dispatch('nextStepPrepare', +1)
    },
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 330px) {
  .form-input__mark {
    display: none;
  }
}
.input__overlay, .form-input-floating-label {
  pointer-events: none;
}

.skip-nip {
  margin-top: 5px;
  font-size: 12px;
  font-weight: 300;
  text-align: left;

  a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/NewMaskedInput.vue